import { useState } from "react";
import { Button } from "../../ui/Button";
import styles from "./WorldCreator.module.css";

export function WorldCreator({ onCreateWorld }) {
  const [worldName, setWorldName] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();
    if (!worldName) return;

    const newWorld = {
      worldName: worldName,
      id: crypto.randomUUID(),
      stippets: [],
    };

    onCreateWorld(newWorld);
    setWorldName("");
    setIsOpen(false);
  }

  return (
    <div className={styles.worldCreator}>
      {isOpen ? (
        <form onSubmit={handleSubmit} className={styles.worldCreatorForm}>
          <button
            className={styles.iconButton}
            type="button"
            aria-label="Close create world"
            onClick={() => {
              setWorldName("");
              setIsOpen(false);
            }}
          >
            ×
          </button>
          <div className={styles.inputGroup}>
            <label htmlFor="world-name">New world</label>
            <input
              id="world-name"
              value={worldName}
              placeholder="e.g. Ember Coast"
              onChange={(e) => setWorldName(e.target.value)}
              autoFocus
            />
          </div>
          <div className={styles.actions}>
            <Button variant="primary" type="submit">
              Add world
            </Button>
          </div>
        </form>
      ) : (
        <Button
          variant="primary"
          fullWidth
          type="button"
          onClick={() => setIsOpen(true)}
        >
          Create world
        </Button>
      )}
    </div>
  );
}
